import React from "react";

const PatchManagement = () => {
    return (
        <div className="container">
            <h1>Patch Management</h1>
            <p>
                Keep your systems secure and up-to-date with efficient patch management.
                Apply updates seamlessly to eliminate vulnerabilities.
            </p>
            <p>
                Advantages:
                <ul>
                    <li>Automated patch scheduling</li>
                    <li>Detailed update logs</li>
                    <li>Minimal downtime</li>
                </ul>
            </p>
        </div>
    );
};

export default PatchManagement;